<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">Browse Businesses by Category</div>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <BusinessCategoryCard 
                        name="Restaurants"
                        imgSrc="https://i.imgur.com/uS1gcdt.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="Shopping"
                        imgSrc="https://i.imgur.com/5om6n2j.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="Nightlife"
                        imgSrc="https://i.imgur.com/N2wFMdL.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="Active Life"
                        imgSrc="https://i.imgur.com/0sXwZyb.png"
                    />
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <BusinessCategoryCard 
                        name="Beauty & Spas"
                        imgSrc="https://i.imgur.com/BL7WC6k.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="Automotive"
                        imgSrc="https://i.imgur.com/y4QabzL.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="Home Services"
                        imgSrc="https://i.imgur.com/xM1aGOZ.png"
                    />
                </b-col>
                <b-col>
                    <BusinessCategoryCard 
                        name="More Categories"
                        imgSrc="https://i.imgur.com/wTFHJPK.png"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    background-color: #f5f5f5;
    width: 100%;
}
</style>

<script>
import BusinessCategoryCard from './BusinessCategoryCard'

export default {
    components: {
        BusinessCategoryCard
    }
}
</script>